import { Injectable } from '@angular/core';
import { BaseSettings } from './settings.models';

@Injectable({
	providedIn: 'root'
})
export class SettingsService extends BaseSettings {

	static instance: SettingsService;
	constructor(){
		super();
		this.load();
		this.apply();
		SettingsService.instance = this;
	}

	load(){
		if( !localStorage.hasOwnProperty('deviceSettings') ) return;
		try{ var settings = JSON.parse(localStorage['deviceSettings']); }
		catch(e){ return; }

		var base_settings = new BaseSettings();

		for( let [k, v] of Object.entries(settings) ){
			if( base_settings.hasOwnProperty(k) ) //Forget old/unused settings
				this[k] = v;

			if( settings.hasOwnProperty('timestamp') )
				this.explicit_keys.add(k);
		}
	}
	save(){
		var base_settings = new BaseSettings();
		var diff_to_save = {}

		for( let [k, v] of Object.entries(base_settings) )
			if( this[k] !== base_settings[k] || this.explicit_keys.has(k) )
				diff_to_save[k] = this[k];

		localStorage['deviceSettings'] = JSON.stringify(diff_to_save);
		this.apply();
	}

	set( k, v, explicit = true ){
		this[k] = v;

		if( explicit )
			this.explicit_keys.add(k);

		this.save()
	}
	toggle( k, explicit = true ){
		this[k] = !(this[k] || false);

		if( explicit )
			this.explicit_keys.add(k);

		this.save()
	}

	revert(){
		var base_settings = new BaseSettings();
		for( let [k, v] of Object.entries(base_settings) )
			this[k] = v;
		localStorage['deviceSettings'] = "{}";
		this.explicit_keys.clear()
		this.apply();
	}


	explicit_keys: Set<string> = new Set(); //Settings that we know has been chosen by the user.
	is_explicit( k ){ return this.explicit_keys.has(k); }


	apply(){
		//Theme
		let token_list = document.documentElement.classList;

		for( let cname of token_list )
			if( cname.startsWith('theme-') )
				token_list.remove(cname);

		if( this.theme_name )
			token_list.add("theme-" + this.theme_name)
	}



}
